import { ButtonHTMLAttributes } from "react";
import styled from "styled-components";
import Spinner from "~/shared/Spinner";

type SystemButtonProps = {
    block?: boolean;
    small?: boolean;
    loading?: boolean;
    round?: boolean;
    icon?: any;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const ButtonContainer = styled.button<{ $round: boolean }>`
    cursor: pointer;
    display: inline-flex;
    text-align: center;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: ${(props) => (props.$round ? "100%" : "4px")};
    min-height: 40px;
    font-weight: bold;
    justify-content: space-between;
    align-items: center;
    ${({$round :round}) =>
        round
            ? `
        height: 40px;
        width: 40px;
        padding: 0;

    `
            : ""}

    color: ${(props) => props.theme.color.base};
    background-color: #fff;
    border: 1px solid ${(props) => props.theme.color.base};

    &:hover {
        color: ${(props) => props.theme.color.primary.background};
        border-color: ${(props) => props.theme.color.primary.background};
    }

    &:active {
        color: ${(props) => props.theme.color.primary.foreground};
        background-color: ${(props) => props.theme.color.primary.background};
        border-color: ${(props) => props.theme.color.primary.background};
    }

    &:disabled {
        color: #fff;
        background-color: #b8b5b5;
        border-color: #b8b5b5;
        opacity: 0.45;
        cursor: not-allowed;
    }

    &.block {
        width: 100%;
        display: block;
    }

    &.small {
        padding: 0.25rem 0.5rem;
        font-size: 0.775rem;
        line-height: 1.5;
        border-radius: 4px;
        min-height: auto;
    }

    &.loading svg {
        width: 24px;
        height: 24px;
    }

    &.small.loading svg {
        width: 21px;
        height: 21px;
    }
`;

const FlatButton: React.FC<SystemButtonProps> = ({
    block = false,
    small = false,
    loading = false,
    round = false,
    icon = null,
    children,
    ...props
}) => {
    const classes = [block ? "block" : "", small ? "small" : "", loading ? "loading" : ""];

    return (
        <ButtonContainer
            type="button"
            $round={round}
            {...props}
            className={`${classes.join(" ")} ${props?.className ?? ""}`}
        >
            {loading ? (
                <Spinner />
            ) : (
                <>
                    {children}
                    {icon}
                </>
            )}
        </ButtonContainer>
    );
};

export default FlatButton;
